import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import SocialLinks from "./social";
import "./Navbar.css";

const useCategory = () => {
  const location = useLocation();
  return new URLSearchParams(location.search).get("category") || "";
};

const Navbar = () => {
  const location = useLocation();
  const currentCategory = useCategory();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  const categories = [
    { name: "Pharmaceutical Division", key: "pharmaceutical" },
    { name: "Industrial Division", key: "industrial" },
    { name: "Food Division", key: "food" }
  ];

  return (
    <div className={`navbar-container ${scrolled ? "scrolled" : ""}`}>
      <nav className="bottom-navbar">
        <div className="logo-container2">
          <Link to="/" onClick={closeMenu}>
            <img src="/assets/Asset 1.png" alt="Logo" className="logo" />
          </Link>
        </div>

        {/* Hamburger icon for mobile */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>

        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li>
            <Link
              to="/"
              className={`nav-link ${location.pathname === "/" || location.pathname === "/home" ? "active" : ""}`}
              onClick={closeMenu}
            >
              Home
            </Link>
          </li>
          <li className={`dropdown ${(location.pathname === "/products" && currentCategory) ? "active" : ""}`}>
            <Link
              to="/products?category=pharmaceutical"
              className="dropdown-link"
              onClick={closeMenu}
            >
              Products
            </Link>
            <ul className="dropdown-menu">
              {categories.map(({ name, key }) => (
                <li key={key} className={`dropdown ${currentCategory === key ? "active" : ""}`}>
                  <Link
                    to={`/products?category=${key}`}
                    className="dropdown-link"
                    onClick={closeMenu}
                  >
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li>
            <Link
              to="/careers"
              className={`nav-link ${location.pathname === "/careers" ? "active" : ""}`}
              onClick={closeMenu}
            >
              Careers
            </Link>
          </li>
          <li>
            <Link
              to="/aboutus"
              className={`nav-link ${location.pathname === "/aboutus" ? "active" : ""}`}
              onClick={closeMenu}
            >
              About us
            </Link>
          </li>
        </ul>

        <div className="social-icons">
          <SocialLinks />
          <a
            href="https://maps.app.goo.gl/DNdtH7G2rPpKNvU16"
            target="_blank"
            rel="noopener noreferrer"
            className="location-container"
            onClick={closeMenu}
          >
            <img src="/assets/loc.png" alt="Location" className="location-icon" />
          </a>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
